import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import moment from 'moment';
import {
  CustomAsyncAutocomplete,
  CustomDateRangePicker,
  CustomIconButton,
  CustomSelect,
} from '../../../../Components';
import { SettingsFour, UserOneIcon } from '../../../../assets/icons';
import { useSelectedTheme, useTranslate } from '../../../../Hooks';

import { GetAllAgentsServices, GetAllBranches } from '../../../../Services';
import { GetAllTeamLeadUsers } from '../../../../Services/userServices';

import useStyles from './styles';


const TransactionTypeOptions = [
  { key: 'TopUp', name: 'TopUp' },
  { key: 'Call', name: 'Call' },
];
function WalletTransactionsFilters({ filters, setFilters }) {
  const { translate } = useTranslate('WalletTransactionsView');
  const {
    theme: { palette },
  } = useSelectedTheme();
  const styles = useStyles();

  const [showFiltersSection, setShowFiltersSection] = useState(true);
  const dateRangeDefault = {
    startDate: null,
    endDate: null,
    key: 'selection',
    selectedDateType: 1,
  };
  const [dateFilter, setDateFilter] = useState(dateRangeDefault);
  return (
    <Box className={styles.filterWrapper}>
      <Box className={styles.filtersButtons}>
        <CustomIconButton
          variant='outlined'
          size='md'
          boxShadow='none'
          color='secondary'
          onClick={() => setShowFiltersSection((prev) => !prev)}
        >
          <SettingsFour
            width='20'
            height='20'
            fill={palette.button.secondary_fg}
          />
        </CustomIconButton>
      </Box>
      {showFiltersSection && (
        <Box className={styles.filtersSection}>
          <Box className={styles.filtersContainer}>
            <CustomAsyncAutocomplete
              rootCustomClasses={styles.inputwrapper}
              className={styles.autoCompleteInput}
              placeholder={translate('agents')}
              onFetchData={GetAllAgentsServices}
              filter={{ pageIndex: 0, pageSize: 1000 }}
              displayLabel={(option) => option?.agentName}
              renderOption={(option) => option?.agentName}
              chipsLabel={(option) => {
                return option?.agentName;
              }}
              onChange={(_e, value) => {
                setFilters({
                  ...filters,
                  agentId: value?.usersId,
                });
              }}
              getOptionSelected={(option, value) =>
                option?.agentId === value?.agentId
              }
              mapper={(data) => data}
              queryKey={'agentName'}
              refetchOnSearch
              inputStartAdornment={
                <UserOneIcon
                  width='20'
                  height='20'
                  fill={palette.foreground.quarterary}
                  className={styles.icon}
                />
              }
            />
            <CustomAsyncAutocomplete
              rootCustomClasses={styles.inputwrapper}
              className={styles.autoCompleteInput}
              placeholder={translate('team-leader')}
              onFetchData={GetAllTeamLeadUsers}
              chipsLabel={(option) =>
                option.teamLeadName || option.teamLeadName || ''
              }
              onChange={(_e, value) => {
                setFilters({
                  ...filters,
                  teamLeaderId: value?.applicationUserId,
                });
              }}
              displayLabel={(option) =>
                option.teamLeadName || option.teamLeadName || ''
              }
              getOptionSelected={(option, value) =>
                value.applicationUserId === option.applicationUserId
              }
              mapper={(data) => data}
              filter={{
                pageIndex: 1,
                pageSize: 1000,
                search: '',
              }}
              queryKey={'search'}
              refetchOnSearch
            />
            <CustomAsyncAutocomplete
              rootCustomClasses={styles.inputwrapper}
              className={styles.autoCompleteInput}
              onFetchData={GetAllBranches}
              chipsLabel={(option) => option.branchName || ''}
              displayLabel={(option) => option.branchName || ''}
              getOptionSelected={(option, value) =>
                option?.branchId === value?.branchId
              }
              onChange={(_e, value) => {
                setFilters({ ...filters, branchId: value?.branchId });
              }}
              mapper={(data) => {
                return data.map((item) => item);
              }}
              queryKey={'branchName'}
              placeholder={translate('branch-name')}
              filter={{ branchName: '' }}
              renderOption={(option) => option?.branchName}
              refetchOnSearch
            />
            <Box className={styles.autoCompleteInput}>
              <CustomSelect
                options={TransactionTypeOptions}
                placeholder={translate('transaction-type')}
                onValueChange={(selectedKey) => {
                  setFilters((prev) => ({
                    ...prev,
                    type: selectedKey,
                  }));
                }}
                variant='default'
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.key}
                isClearable
              />
            </Box>
          </Box>
          <Box className={styles.dateFilterContainer}>
            <Box className={styles.dateFilter}>{'Transaction Created'}</Box>
            <CustomDateRangePicker
              onClearClicked={() => {
                setDateFilter(dateRangeDefault);
                setFilters({
                  ...filters,
                  dateFrom: '',
                  dateTo: '',
                });
              }}
              ranges={[dateFilter]}
              onDateChanged={(selectedDate) => {
                setDateFilter((item) => ({
                  ...item,
                  startDate: selectedDate.selection?.startDate,
                  endDate: !selectedDate.selection?.endDate
                    ? null
                    : new Date(
                        moment(selectedDate.selection?.endDate).endOf('day')
                      ),
                  key: 'selection',
                }));
              }}
              emptyLabel='dd/mm/yyyy'
              displayFormat='MMM D, YYYY'
              onSave={(ranges) => {
                setFilters({
                  ...filters,
                  dateFrom: ranges.startDate,
                  dateTo: ranges.endDate,
                });
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default WalletTransactionsFilters;
